import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { showNotification } from 'Store/Notification/Notification.action';
import { showPopup } from 'Store/Popup/Popup.action';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import ProductListQuery from 'Query/ProductList.query';
import { fetchMutation } from 'Util/Request';
import ProductPriceAlert, { PRICE_ALERT_POPUP_ID } from './ProductPriceAlert.component';

export const mapStateToProps = state => ({
    isSignIn: state.MyAccountReducer.isSignedIn,
    email: state.MyAccountReducer.customer.email
});

export const mapDispatchToProps = dispatch => ({
    showPopup: payload => dispatch(showPopup(PRICE_ALERT_POPUP_ID, payload)),
    hideActiveOverlay: () => dispatch(hideActiveOverlay()),
    showNotification: (type, message) => dispatch(showNotification(type, message))
});

export class ProductPriceAlertContainer extends PureComponent {
    containerFunctions = {
        onTriggerClick: this._onTriggerClick.bind(this),
        onPriceAlertSubmitSuccess: this._onPriceAlertSubmitSuccess.bind(this),
        showPopup: this._showPopup.bind(this)
    };

    containerProps = () => {
        const { product_type } = this.props;
        return {
            product_type
        };
    };


    _onPriceAlertSubmitSuccess(fields) {
        const { product_id, hideActiveOverlay } = this.props;
        const { email } = fields;

        const input = {
            product_id,
            email
        }

        this._subscribePriceAlert(input);
        hideActiveOverlay();
    }

    _onTriggerClick() {
        const { isSignIn, product_id, email } = this.props;

        if (isSignIn) {
            const input = {
                product_id,
                email
            }
            this._subscribePriceAlert(input);
        } else {
            this._showPopup();
        }
    }

    _showPopup() {
        const { showPopup } = this.props;

        showPopup({ title: __("Let me know when it's on sale") });
    }

    _subscribePriceAlert(input) {
        const { showNotification } = this.props;

        fetchMutation(ProductListQuery.subscribePriceAlert(input)).then (
            ({ subscribePriceAlert: { message, status: type } }) => showNotification(type, message),
            error => console.log(error)
        );
    }

    render() {
        return (
            <ProductPriceAlert
                { ...this.containerFunctions }
                { ...this.containerProps() }
            />
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductPriceAlertContainer);
